import { SELECT_INBOX_TAB } from 'actions/types';
import * as tabs from 'constants/tabNames';

const INITIAL_STATE = {
  [tabs.NOMINATED]: '',
  [tabs.LIVE_CHAT]: '',
  [tabs.ASSIGNED]: '',
  [tabs.ALL]: '',
};

const previousSelectedTicketId = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_INBOX_TAB:
      const { prevSelectedTicketId, prevSelectedTab, tabName: destinationTabName } = action;

      return Object.assign({}, state, {
        [prevSelectedTab]: prevSelectedTicketId,
        [destinationTabName]: '',
      });
    default:
      return state;
  }
};

export default previousSelectedTicketId;
